import {
  core,
  languages,
  frontend,
  backend,
  databases,
  cloudDevops,
  testingTools,
} from "../utils/tecnologies";
import Chip from "./chip";
import BottomLine from "./bottomLine";
import Subtitle from "./subtitle";

function StacksContainer({ title, list }) {
  return (
    <div className="pt-6">
      <p className="pb-3 text-center font-mono text-slate-500 uppercase tracking-widest text-xs">
        {title}
      </p>
      <div className="flex justify-center items-center flex-wrap gap-2">
        {list.map((name, index) => (
          <Chip key={index} text={name} />
        ))}
      </div>
    </div>
  );
}

export default function Techs() {
  return (
    <div className="w-[90%] h-full py-12 flex flex-col justify-center items-center md:w-[70%] lg:w-[60%]">
      <Subtitle
        text={"Skills & Technologies"}
        className="text-3xl md:text-5xl"
      />
      <BottomLine />

      <p className="pt-4 text-center font-mono text-slate-500 uppercase tracking-widest text-xs">
        Core stack
      </p>
      <div className="pt-3 flex justify-center items-center flex-wrap gap-2">
        {core.map((name, index) => (
          <Chip key={index} text={name} filled />
        ))}
      </div>

      <StacksContainer title="Languages" list={languages} />
      <StacksContainer title="Frontend" list={frontend} />
      <StacksContainer title="Backend" list={backend} />
      <StacksContainer title="Databases" list={databases} />
      <StacksContainer title="Cloud & DevOps" list={cloudDevops} />
      <StacksContainer title="Testing & Tools" list={testingTools} />
    </div>
  );
}
